import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CalendarDays, Phone } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "./SmoothScroll";
import { CABINET } from "@/lib/content";

const pill = "flex items-center gap-2 whitespace-nowrap rounded-full py-3 pl-3.5 pr-4 text-[0.85rem] font-semibold shadow-[0_10px_30px_-8px_rgba(28,40,38,0.55)]";

export const FloatingRdv = () => {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const go = () => (pathname === "/" ? scrollToId("contact") : navigate("/#contact"));

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="floating-actions"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-5 z-40 flex justify-center gap-2 px-3 lg:hidden"
        >
          <motion.button type="button" onClick={go} whileTap={{ scale: 0.96 }} data-testid="floating-rdv-button"
            className={`${pill} border border-[#FAF8F5]/50 bg-[#B39158] text-[#1C2826]`}>
            <CalendarDays size={16} strokeWidth={1.5} />
            Prendre rendez-vous
          </motion.button>
          <motion.a href={CABINET.mobileHref} whileTap={{ scale: 0.96 }} data-testid="floating-call-button"
            className={`${pill} border border-[#B39158]/60 bg-[#3D5A4C] text-[#FAF8F5]`}>
            <Phone size={15} strokeWidth={1.5} className="text-[#D9C193]" />
            Appeler le cabinet
          </motion.a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
